import React, { useState, useEffect, Fragment } from 'react';
import Typography from '@material-ui/core/Typography';
import Loader from './Loader';
import Timeline_item_event from './Timeline_item_event';
import EmailIcon from '@material-ui/icons/Email';
import MouseIcon from '@material-ui/icons/Mouse';
import VisibilityIcon from '@material-ui/icons/Visibility';
import axios from 'axios';

export default function TimelineEmailEvents(props) {
  const [emailEvents, setEmailEvents] = useState(undefined);

  useEffect(() => {
    if (props.email_message !== undefined) {
      axios.get(`/api/email/${props.email_message.id}/events`).then(function (response) {
        setEmailEvents(response.data);
      });
    }
  }, []);


  let pending=false;if (props.timeline_item.type==0 && props.timeline_item.sub_type==2 && new Date(props.timeline_item.date_time).getTime() <= new Date().getTime()) {pending=true;}
  let sent_event=false; if(emailEvents!=undefined){for(let ee of emailEvents){if(ee.sent_event==true){sent_event=true;}}}
  if(emailEvents!=undefined && sent_event==false && pending==false){emailEvents.unshift({sent_event:true, created_at:props.timeline_item.date_time})}
  return (
    <Fragment>
      {emailEvents === undefined ? (
        <div style={{ height: '100%', width: '100%' }}>
          <Loader loading embed />
        </div>
      ) : (
        <Fragment>
          {emailEvents.map((ee, index) => (
            <Timeline_item_event index={index} date_time={ee.created_at} title={ee.sent_event==true?'Sent':ee.email_message_link === undefined ? 'Opened' : 'Click'} icon={ee.sent_event==true?(
              <EmailIcon color="primary" fontSize="small"/>
            ):ee.email_message_link !== undefined ? (
              <MouseIcon color="secondary" fontSize="small" />
            ) : (
              <VisibilityIcon style={{color:'green'}} fontSize="small" />
            )} extra_content={<div style={{overflowX:'none', width:'100%'}}>{(ee.email_message_link !== undefined)?<Typography variant="caption" color="textSecondary"><a href={ee.email_message_link.url} target="_blank" rel="noopener noreferrer">{(ee.email_message_link.url.length>28)?ee.email_message_link.url.substring(0, 28)+'...':ee.email_message_link.url}</a></Typography>:null}</div>}/>))}
        </Fragment>
      )}
    </Fragment>
  );
}
